export default () => undefined;

export const closeInAppBrowser = () => undefined;
